export interface Kampanya {
  id: string;
  baslik: string;
  aciklama: string;
  eskiFiyat: string;
  yeniFiyat: string;
  etiket: string;
  gorsel: string;
  detayGorsel: string;
  detayAciklama: string;
  avantajlar: string[];
  musteriYorumu: { yorum: string; isim: string; avatar: string };
}

export const kampanyalar: Kampanya[] = [
  {
    id: "cilt-yenileme",
    baslik: "Cilt Yenileme Paketi",
    aciklama: "Derin temizlik, peeling ve nemlendirme ile cildinizi yenileyin. Işıltılı ve genç bir görünüm için.",
    eskiFiyat: "₺2.800",
    yeniFiyat: "₺1.490",
    etiket: "En Çok Tercih Edilen",
    gorsel: "https://readdy.ai/api/search-image?query=luxury%20facial%20treatment%20close%20up%20glowing%20healthy%20skin%20woman%20receiving%20premium%20skincare%20treatment%20soft%20cream%20background%20elegant%20beauty%20spa%20professional%20photography%20warm%20lighting&width=600&height=400&seq=kamp001&orientation=landscape",
    detayGorsel: "https://readdy.ai/api/search-image?query=premium%20facial%20skincare%20treatment%20woman%20glowing%20skin%20luxury%20beauty%20clinic%20white%20marble%20elegant%20professional%20aesthetician%20applying%20serum%20warm%20golden%20light&width=800&height=500&seq=kamp001d&orientation=landscape",
    detayAciklama: "Cilt Yenileme Paketimiz, cildinizin derinlemesine temizlenmesi, ölü deri hücrelerinin uzaklaştırılması ve yoğun nemlendirme ile tamamlanan 3 aşamalı bir uygulamadır. Uzman estetisyenlerimiz tarafından uygulanan bu paket, cildinizi anında daha parlak, daha genç ve daha sağlıklı gösterir.",
    avantajlar: [
      "Derin gözenek temizliği",
      "Kimyasal peeling uygulaması",
      "Hyalüronik asit nemlendirme",
      "Kolajen destekleyici maske",
    ],
    musteriYorumu: {
      yorum: "İlk seanstan sonra cildimde inanılmaz bir fark hissettim. Arkadaşlarım yaşımı 5 yıl küçük tahmin etmeye başladı!",
      isim: "Selin K.",
      avatar: "https://readdy.ai/api/search-image?query=beautiful%20turkish%20woman%20smiling%20portrait%20soft%20background%20professional%20headshot%20warm%20tones&width=60&height=60&seq=av001&orientation=squarish",
    },
  },
  {
    id: "lazer-epilasyon",
    baslik: "Lazer Epilasyon Fırsatı",
    aciklama: "6 seans lazer epilasyon ile kalıcı pürüzsüzlüğe kavuşun. Tüm vücut bölgelerine özel paketler.",
    eskiFiyat: "₺4.200",
    yeniFiyat: "₺2.190",
    etiket: "Sınırlı Süre",
    gorsel: "https://readdy.ai/api/search-image?query=laser%20hair%20removal%20treatment%20professional%20beauty%20clinic%20smooth%20skin%20woman%20legs%20luxury%20aesthetic%20clean%20white%20background%20modern%20equipment&width=600&height=400&seq=kamp002&orientation=landscape",
    detayGorsel: "https://readdy.ai/api/search-image?query=professional%20laser%20hair%20removal%20treatment%20beauty%20clinic%20modern%20equipment%20smooth%20skin%20luxury%20aesthetic%20clean%20environment%20warm%20lighting&width=800&height=500&seq=kamp002d&orientation=landscape",
    detayAciklama: "Lazer Epilasyon paketimiz, FDA onaylı en son teknoloji cihazlarla uygulanmaktadır. 6 seans boyunca düzenli aralıklarla gerçekleştirilen uygulama, kalıcı tüy azalması sağlar. Her cilt tipine uygun parametreler ile güvenli ve etkili sonuçlar elde edilir.",
    avantajlar: [
      "FDA onaylı lazer teknolojisi",
      "Her cilt tipine uygun",
      "Ağrısız uygulama",
      "Kalıcı sonuçlar",
    ],
    musteriYorumu: {
      yorum: "6 seans sonunda gerçekten kalıcı sonuç aldım. Artık tıraş stresi yok, her gün pürüzsüz hissediyorum.",
      isim: "Ayşe M.",
      avatar: "https://readdy.ai/api/search-image?query=elegant%20turkish%20woman%20smiling%20portrait%20soft%20cream%20background%20professional%20headshot%20warm%20tones%20natural%20beauty&width=60&height=60&seq=av002&orientation=squarish",
    },
  },
  {
    id: "dudak-renklendirme",
    baslik: "Dudak Renklendirme",
    aciklama: "Kalıcı dudak renklendirme ile her gün makyajsız güzel dudaklara sahip olun.",
    eskiFiyat: "₺3.500",
    yeniFiyat: "₺1.890",
    etiket: "Yeni Sezon",
    gorsel: "https://readdy.ai/api/search-image?query=lip%20treatment%20beauty%20close%20up%20perfect%20lips%20natural%20pink%20color%20luxury%20beauty%20clinic%20professional%20cosmetic%20treatment%20elegant%20soft%20background&width=600&height=400&seq=kamp003&orientation=landscape",
    detayGorsel: "https://readdy.ai/api/search-image?query=permanent%20lip%20color%20treatment%20beauty%20clinic%20close%20up%20perfect%20natural%20lips%20professional%20cosmetic%20procedure%20elegant%20luxury%20aesthetic%20warm%20lighting&width=800&height=500&seq=kamp003d&orientation=landscape",
    detayAciklama: "Kalıcı Dudak Renklendirme uygulaması, dudaklarınıza doğal ve uzun ömürlü bir renk kazandırır. Uzman pigmentasyon uzmanlarımız tarafından gerçekleştirilen bu uygulama, dudak şeklinizi belirginleştirir ve doğal görünümlü bir renk tonu sağlar.",
    avantajlar: [
      "Doğal görünümlü sonuç",
      "2-3 yıl kalıcılık",
      "Renk seçeneği",
      "Ücretsiz dokunma seansı",
    ],
    musteriYorumu: {
      yorum: "Artık sabahları makyaj yapmadan çıkabiliyorum. Dudaklarım her zaman bakımlı ve güzel görünüyor.",
      isim: "Zeynep A.",
      avatar: "https://readdy.ai/api/search-image?query=young%20turkish%20woman%20smiling%20portrait%20soft%20background%20professional%20headshot%20warm%20natural%20tones%20beauty&width=60&height=60&seq=av003&orientation=squarish",
    },
  },
  {
    id: "g5-sikilasma",
    baslik: "G5 Sıkılaşma",
    aciklama: "G5 masaj teknolojisi ile selülit azaltma ve cilt sıkılaştırma. Görünür sonuçlar garantili.",
    eskiFiyat: "₺3.200",
    yeniFiyat: "₺1.690",
    etiket: "Popüler",
    gorsel: "https://readdy.ai/api/search-image?query=body%20massage%20treatment%20luxury%20spa%20professional%20beauty%20clinic%20smooth%20skin%20toning%20treatment%20elegant%20cream%20background%20warm%20lighting%20professional%20photography&width=600&height=400&seq=kamp004&orientation=landscape",
    detayGorsel: "https://readdy.ai/api/search-image?query=G5%20body%20massage%20treatment%20luxury%20beauty%20spa%20professional%20equipment%20smooth%20skin%20toning%20cellulite%20reduction%20elegant%20warm%20lighting&width=800&height=500&seq=kamp004d&orientation=landscape",
    detayAciklama: "G5 Sıkılaşma uygulaması, özel titreşim teknolojisi ile derin doku masajı yaparak selülit görünümünü azaltır ve cilt elastikiyetini artırır. 10 seanslık program ile vücudunuzda belirgin bir sıkılaşma ve şekillendirme etkisi elde edersiniz.",
    avantajlar: [
      "Selülit azaltma",
      "Cilt sıkılaştırma",
      "Kan dolaşımını artırma",
      "Vücut şekillendirme",
    ],
    musteriYorumu: {
      yorum: "10 seans sonunda bacaklarımdaki selülit görünümü inanılmaz azaldı. Kendime olan güvenim arttı!",
      isim: "Fatma D.",
      avatar: "https://readdy.ai/api/search-image?query=mature%20turkish%20woman%20smiling%20portrait%20soft%20cream%20background%20professional%20headshot%20warm%20tones%20elegant%20beauty&width=60&height=60&seq=av004&orientation=squarish",
    },
  },
  {
    id: "hydrafacial",
    baslik: "Hydrafacial Bakım",
    aciklama: "Dünyaca ünlü Hydrafacial teknolojisi ile anlık parlaklık ve derin nemlendirme.",
    eskiFiyat: "₺2.400",
    yeniFiyat: "₺1.290",
    etiket: "Çok Satan",
    gorsel: "https://readdy.ai/api/search-image?query=hydrafacial%20treatment%20luxury%20beauty%20clinic%20glowing%20skin%20woman%20professional%20skincare%20hydration%20treatment%20elegant%20white%20background%20warm%20golden%20light%20premium%20aesthetic&width=600&height=400&seq=kamp005&orientation=landscape",
    detayGorsel: "https://readdy.ai/api/search-image?query=hydrafacial%20professional%20treatment%20beauty%20clinic%20glowing%20radiant%20skin%20woman%20luxury%20aesthetic%20clean%20white%20marble%20background%20warm%20lighting%20premium%20skincare&width=800&height=500&seq=kamp005d&orientation=landscape",
    detayAciklama: "Hydrafacial, dünyada en çok tercih edilen cilt bakım uygulamalarından biridir. Temizleme, peeling, ekstraksiyon ve nemlendirme adımlarını tek seansta birleştiren bu uygulama, cildinizi anında parlak ve genç gösterir. Herhangi bir iyileşme süreci gerektirmez.",
    avantajlar: [
      "Anlık parlaklık etkisi",
      "Derin nemlendirme",
      "Gözenek temizliği",
      "İyileşme süreci yok",
    ],
    musteriYorumu: {
      yorum: "Seanstan çıktığımda cildim o kadar parlak ve nemli görünüyordu ki herkes ne yaptığımı sordu!",
      isim: "Merve T.",
      avatar: "https://readdy.ai/api/search-image?query=young%20elegant%20turkish%20woman%20smiling%20portrait%20soft%20background%20professional%20headshot%20warm%20natural%20tones%20glowing%20skin&width=60&height=60&seq=av005&orientation=squarish",
    },
  },
];
